import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../styles/bootstrap.min.css';
import '../styles/style.css';
import MainSidebar from '../components/MainSidebar';
import rightarrow from '../assets/images/right.svg';
import config from '../config/config';

const Walletaddress = () => {
  const [userData, setUserData] = useState({ user_name: '', wallet_address: '', wallet_address_type: '' });
  const [newWalletAddress, setNewWalletAddress] = useState('');
  const [walletAddressType, setWalletAddressType] = useState(''); // state for wallet address type
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/Login');
      return;
    }

    const fetchUserDetails = async () => {
      try {
        const response = await axios.get(`${config.baseURL}/current-user-details`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const userDetails = response.data.data.user_details;
        const user = response.data.data.user;

        // Set user details including wallet address and wallet address type
        setUserData({
          ...userDetails,
          user_name: user.user_name,
          wallet_address: userDetails.wallet_address || '',
          wallet_address_type: userDetails.wallet_address_type || '', // added wallet address type
        });

        // Set the wallet address and wallet address type for editing (if exists)
        setNewWalletAddress(userDetails.wallet_address || '');
        setWalletAddressType(userDetails.wallet_address_type || '');

        setLoading(false);
      } catch (error) {
        console.error('Error fetching user details', error);
        setLoading(false);
      }
    };

    fetchUserDetails();
  }, [navigate]);

  const handleWalletAddressChange = (e) => {
    setNewWalletAddress(e.target.value);
  };

  const handleWalletAddressTypeChange = (e) => {
    setWalletAddressType(e.target.value); // handle change for wallet address type
  };

  const handleBackClick = () => {
    navigate(-1); // Go back to the previous page
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('token');
    try {
      const response = await axios.post(`${config.baseURL}/update-wallet-address`, 
        { wallet_address: newWalletAddress, wallet_address_type: walletAddressType }, // send wallet address type in the request
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.success) {
        setSuccessMessage('Wallet address updated successfully');
        setErrorMessage('');
        setUserData({
          ...userData,
          wallet_address: newWalletAddress,
          wallet_address_type: walletAddressType, // update wallet address type in state
        });
      } else {
        setErrorMessage(response.data.message);
        setSuccessMessage('');
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.message) {
        setErrorMessage(error.response.data.message);
      } else {
        setErrorMessage('Error updating wallet address');
      }
      setSuccessMessage('');
      console.error('Error updating wallet address', error);
    }
  };

  return (
    <div>
      <div className="main_patreonpass_wrapper">
        <div className="patreonpass_container">
          <div className="left_sidebar">
            <MainSidebar />
          </div>
          <div className="patreonpass_main_content edit_profile_settings" id="content">
            <div className="left_main_content">
              <div className="feed_wrapper">
                <div className="page_title_with_dropdown notification_page">
                  <div className="page_heading">
                    <button className="profile_back_btn" onClick={handleBackClick}>
                      <svg width={54} height={54} viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M48 27.5363L5.99998 27.5363M5.99998 27.5363L27 49.0532M5.99998 27.5363L27 6.3032" stroke="#222" strokeWidth={6} strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </button>
                    <h1>SETTINGS</h1>
                  </div>
                </div>
                <div className="menus_all_wrapper">
                  <div className="edit_settings_menu_list">
                    <h3><a href={`/${userData.user_name}`}>@{userData.user_name}</a></h3>
                    <ul>
                      <li><Link to="/EditProfile">Profile <span className="menu_arrow"><img src={rightarrow} alt="" /></span></Link></li>
                      <li><Link className="active_profile_menu" to="/AccountSettings">Account <span className="menu_arrow"><img src={rightarrow} alt="" /></span></Link></li>
                      <li><Link to="/PrivacySafetySettings">Privacy and safety <span className="menu_arrow"><img src={rightarrow} alt="" /></span></Link></li>
                      <li><Link to="/NotificationSettings">Notifications <span className="menu_arrow"><img src={rightarrow} alt="" /></span></Link></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="right_main_content">
              <form onSubmit={handleSubmit}>
                <div className="page_title_with_dropdown notification_page">
                  <div className="page_heading">
                    <h1>Wallet Address</h1>
                  </div>
                </div>
                <div className="fields_menu_bottom_box_edit_account edit_username_fields">
                  <div className="editable_fields_user edit_username_field edit_wallet_address">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="mb-4 position_relative">
                          <input
                            type="text"
                            value={newWalletAddress}
                            onChange={handleWalletAddressChange}
                            className="form-control"
                            id="new_wallet_address"
                            placeholder="Enter new wallet address" maxLength={45}
                            required
                          />
                          <label htmlFor="new_wallet_address" className="placeholder-label active_label">
                            Wallet Address
                          </label>
                        </div>
                      </div>
                    </div>

                    {/* Wallet Address Type Select */}
                    <div className="row">
                      <div className="col-md-12">
                        <div className="mb-4 position_relative">
                          <select
                            value={walletAddressType}
                            onChange={handleWalletAddressTypeChange}
                            className="form-control"
                            id="wallet_address_type"
                            required
                          >
                            {/* <option value="">Select Wallet Type</option> */}
                            <option value="TRC20">TRC20</option>
                            <option value="ERC20">ERC20</option>
                            <option value="BSC (BEP20)">BSC (BEP20)</option>
                          </select>
                          <label htmlFor="wallet_address_type" className="placeholder-label active_label">
                            Wallet Address Type
                          </label>
                        </div>
                      </div>
                    </div>

                    {errorMessage && (
                      <div className="row">
                        <div className="col-md-12 mb-4 text-danger">
                          {errorMessage}
                        </div>
                      </div>
                    )}
                    {successMessage && (
                      <div className="row">
                        <div className="col-md-12 mb-4 text-success fdg">
                          {successMessage}
                        </div>
                      </div>
                    )}

                    <div className="divider_line" />
                    <div className="row">
                      <div className="col-md-12 text-right">
                        <button type="submit" className="g-btn m-rounded border-none m-border m-block">
                          Update Wallet Address
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Walletaddress;
